import { DatePicker, Form, Input, Select } from "antd";
import '@xyflow/react/dist/style.css';
import { StyledButton } from "src/styled_components/StyledButton";
import { UserAddOutlined } from "@ant-design/icons";
import { operationCreateRequest } from "src/store/actions/operations";
import { useDispatch } from "react-redux";


export const NewOperations = () => {
  const dispatch = useDispatch()
  return (
    <Form
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      style={{ maxWidth: 600 }}
      onFinish={(values) => {
        console.log("🚀 ~ NewOperations ~ values:", values)
        dispatch(operationCreateRequest(values))
      }}
    >
      <Form.Item label="Name" name="name">
        <Input />
      </Form.Item>
      <Form.Item label="Category" name="category">
        <Select>
          <Select.Option value="demo">Demo</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="Description" name="description">
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item label="Date" name="date">
        <DatePicker.RangePicker />
      </Form.Item>
      <Form.Item label="Customer" name="customer">
        <Input />
      </Form.Item>
      <Form.Item label="Lab Location" name="location">
        <Select>
          <Select.Option value="demo">Demo</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="Tags" name="tags">
        <Select
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Tags Mode"
          onChange={undefined}
          options={[]}
        />
      </Form.Item>
      <Form.Item label="Add Members" name="members">
        <StyledButton icon={<UserAddOutlined />}>Add Member</StyledButton>
      </Form.Item>
      <StyledButton htmlType="submit" type="primary">Create</StyledButton>
    </Form>
  );
}